import { fitTitle, fitDescription } from "@/lib/seo-text";
import { createFileRoute } from "@tanstack/react-router";

import { LocationPage } from "@/components/location-page";
import { faqSchema } from "@/lib/firm";
import { CONTENT } from "@/lib/locations/battery-hill";

export const Route = createFileRoute("/battery-hill")({
  head: () => ({
    meta: [
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { title: fitTitle(CONTENT.metaTitle) },
      { name: "description", content: fitDescription(CONTENT.description) },
      { property: "og:title", content: fitTitle(CONTENT.metaTitle) },
      { property: "og:description", content: fitDescription(CONTENT.description) },
      { property: "og:url", content: "https://coastsidelaw.com.au/battery-hill" },
    ],
    links: [{ rel: "canonical", href: "https://coastsidelaw.com.au/battery-hill" }],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(faqSchema(CONTENT.faqs)) }],
  }),
  component: () => <LocationPage content={CONTENT} />,
});
